import api from "./api";
import TokenService from "./token.service";
class UploadDocsService {
  upload(formData, onUploadProgress) {
    return api.post("/docs/upload", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        // include token explicitly to ensure uploads include auth
        "x-access-token": TokenService.getLocalAccessToken(),
      },
      onUploadProgress,
    });
  }

  uploadPhoto(file, onUploadProgress) {
    let formData = new FormData();
    formData.append("file", file);
    return api.post(`/members/upload`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        "x-access-token": TokenService.getLocalAccessToken(),
      },
      onUploadProgress,
    });
  }

  uploadExcel(file, onUploadProgress) {
    let formData = new FormData();
    formData.append("file", file);
    return api.post(`/dropboxfiles/upload`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        "x-access-token": TokenService.getLocalAccessToken(),
      },
      onUploadProgress,
    });
  }
  getFiles() {
    // Use a relative path to escape api baseURL (backend serves /docs at root)
    return api.get(`../docs`);
  }
  getPhotos() {
    // Use relative path to hit backend /files (not /api/files)
    return api.get(`../files`);
  }
}
export default new UploadDocsService();
